type ImageCdnMarket = { norceImageCdn: string } | { imageCdn: string };

export default function getNorceCdnImageUrl(
  imageKey: string = "",
  market: ImageCdnMarket,
) {
  if (!imageKey) return "";
  const url = "imageCdn" in market ? market.imageCdn : market.norceImageCdn;
  if (imageKey.includes(url)) return imageKey;
  return `${url}/${imageKey}`;
}
